<template> 
  <div ref="bienvenidaRef" class="bienvenida-container">
    <!-- Separador decorativo -->

    <!-- Texto debajo -->
    <div ref="textoRef" class="bienvenida-text">
      ¡Lo más importante es su asistencia!<br />
      Si deseas realizar una muestra de cariño estaremos muy agradecidos.
    </div>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'BienvenidaPage',
  setup() {
    const bienvenidaRef = ref(null);
    const separadorRef = ref(null);
    const textoRef = ref(null);

    onMounted(() => {
      nextTick(() => {
        ScrollTrigger.create({
          trigger: bienvenidaRef.value,
          start: "top 85%",
          once: true,
          onEnter: () => {
            gsap.fromTo(
              separadorRef.value,
              { opacity: 0, x: 100, scale: 0.8 },
              { opacity: 1, x: 0, scale: 1, duration: 1.2, ease: "power3.out", delay: 0.4 }
            );

            gsap.fromTo(
              textoRef.value,
              { opacity: 0, x: 100, scale: 0.95 },
              { opacity: 1, x: 0, scale: 1, duration: 1.4, ease: "power3.out", delay: 0.9 }
            );
          }
        });
      });
    });

    return {
      bienvenidaRef,
      separadorRef,
      textoRef
    };
  }
};
</script>
<style scoped>
.bienvenida-container {
  position: relative;
  width: 100%;
  max-width: 800px;
  margin: 50px auto;
  padding: 10px 0; /* margen superior e inferior, sin exceso lateral */
  text-align: center;
  background-color: #e8edf2;
  
  color: #1a1a1a;  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Ornamento floral */
.decorative-svg {
  width: 100%;
  max-width: 50%;
  height: auto;
  margin-bottom: 20px;
  opacity: 0;
}

/* Texto elegante */
.bienvenida-text {
  font-family: 'padres';
  font-size: 16px;
  color: #efe9e9;
  line-height: 1.8;
  letter-spacing: 1px;
  opacity: 0;
  padding: 0 10px; /* espacio lateral reducido */
  width: 100%; /* asegura que ocupe todo el ancho disponible */
  box-sizing: border-box; /* incluye padding dentro del width */
}
</style>
